module.exports = __webpack_public_path__ + "static/media/ComingSoon.b27395f6.png";